import { Deal } from '../../types/header/Deal';
import { SearchResult } from '../../types/header/SearchResult';
import { GetOneFromPath, Put } from '../api/GenericClient';

const initialPath = '/common';

async function getRecentOrFavorite(isFavorite: boolean): Promise<Array<Deal>> {
  const url = isFavorite ? '/favorites' : '/recents';
  const apiPath = initialPath.concat(url);
  return await GetOneFromPath<Array<Deal>>(apiPath);
}

async function searchDeals(term: string, showInactiveDeals: boolean): Promise<Array<SearchResult>> {
  const apiPath = `/search/deals?term=${term}&showInactiveDeals=${showInactiveDeals}`;
  return await GetOneFromPath<Array<SearchResult>>(apiPath);
}

async function reactivateDeal(dealerId: string, vin: string, closedDealId: string) {
  const url = `/dealstatus?dealerId=${dealerId}&vin=${vin}&closedDealId=${closedDealId}&isDealActive=${true}`;
  const apiPath = initialPath.concat(url);
  return await Put(apiPath);
}

export const DealsService = {
  getRecentOrFavorite,
  searchDeals,
  reactivateDeal,
};
